export enum DateFormat {
    SHORT_NO_YEAR = 'DD-MM',
    SHORT = 'DD-MM-YYYY',
    MEDIUM = 'D MMM YYYY',
    LONG = 'D MMMM YYYY',
    SHORT_TIME = 'DD-MM-YYYY, HH:mm',
    SHORT_TIME_SPECIFIC = 'DD-MM-YYYY, HH:mm:ss',
    SHORT_DATE_TIME = 'DD MMM, HH:mm',
    LONG_DAY = 'dddd - D MMM YYYY',
    SHORT_DAY = 'dddd, HH:mm ',
}

/**
 * Resets a date to the start of the day, preventing issues with UTC offset
 * @returns a date with zero hours, minutes, seconds and milliseconds
 */
export const toDateOnStartDay = (date: Date): Date => {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0))
}
